import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import AuthenticatedLayout from '../../layouts/AuthenticatedLayout';
import { Card } from '@components/bootstrap';
import DashboardEcommerce from '../../components/DashboardEcommerce';
import DashboardAnalytics from '../../components/DashboardAnalytics';
import DashboardAds from '../../components/DashboardAds';
import DashboardInstagram from '../../components/DashboardInstagram';
import ChangelogViewer from '../../components/ChangelogViewer';
import { canAccessPlanFeature, hasPermission } from '../../utils/permissions';
import './Dashboard.scss';
const Dashboard = () => {
    const navigate = useNavigate();
    const { user, userRole, userPlan, isAuthenticated, logout } = useAuth();
    // const [recentActivity, setRecentActivity] = useState(mockData.recentActivity);
    const [activeTab, setActiveTab] = useState('ecommerce');
    // Simple permission checks
    const planType = userPlan?.type || null;
    const canAccessAnalytics = canAccessPlanFeature(planType, 'analytics');
    const canAccessInstagram = hasPermission(userRole || '', 'instagram') && canAccessPlanFeature(planType, 'instagram');
    const handleLoginClick = () => {
        navigate('/login');
    };
    const handleLogoutClick = () => {
        logout();
        navigate('/login');
    };
    const handleSettingsClick = () => {
        navigate('/settings');
    };
    const handleCardClick = (componentId) => {
        console.log('Card clicked:', componentId);
    };
    // ===== REGRAS DE NEGÓCIO PARA FEATURES =====
    console.log('🎯 Dashboard - User permissions:', {
        role: userRole,
        plan: userPlan?.type,
        features: user?.features
    });
    // Simple feature checks
    const hasInstagram = canAccessInstagram;
    const hasEcommerce = true; // Ecommerce sempre disponível para demonstração
    const hasAds = false; // Simplificado - remover ads por enquanto
    // Features especiais
    const isSuperAdmin = userRole === 'superadmin';
    // Preparar tabs baseadas em permissões
    const dashboardTabs = [
        // Instagram - Todos os roles + todos os planos
        ...(hasInstagram ? [{
                id: 'instagram',
                label: '📸 Instagram',
                component: _jsx(DashboardInstagram, {})
            }] : []),
        // E-commerce - Moderator+ + Standard+
        ...(hasEcommerce ? [{
                id: 'ecommerce',
                label: '🛒 E-commerce',
                component: _jsx(DashboardEcommerce, {})
            }] : []),
        // Ads - Admin+ + Standard+
        ...(hasAds ? [{
                id: 'ads',
                label: '📢 Ads',
                component: _jsx(DashboardAds, {})
            }] : []),
        // Analytics - Sempre disponível (exemplo)
        {
            id: 'analytics',
            label: '📊 Analytics',
            component: _jsx(DashboardAnalytics, {})
        },
        // Histórico - Apenas superadmin
        ...(isSuperAdmin ? [{
                id: 'history',
                label: '📋 Histórico',
                component: _jsx(ChangelogViewer, {})
            }] : [])
    ];
    // Definir tab ativa padrão baseada nas permissões
    const getDefaultTab = () => {
        if (hasInstagram)
            return 'instagram';
        if (hasEcommerce)
            return 'ecommerce';
        if (hasAds)
            return 'ads';
        return 'analytics';
    };
    // Atualizar tab ativa se necessário
    React.useEffect(() => {
        const availableTabs = dashboardTabs.map(tab => tab.id);
        if (!availableTabs.includes(activeTab)) {
            setActiveTab(getDefaultTab());
        }
    }, [user, activeTab]);
    return (_jsx(AuthenticatedLayout, { title: "Dashboard", subtitle: "An\u00E1lise e estat\u00EDsticas do sistema", tabs: dashboardTabs, activeTab: activeTab, onTabChange: setActiveTab, children: _jsx("div", { className: "dashboard-content", children: _jsxs("div", { className: "tab-content", id: "dashboardTabContent", children: [_jsx("div", { className: `tab-pane fade ${activeTab === 'ecommerce' ? 'show active' : ''}`, id: "ecommerce", role: "tabpanel", "aria-labelledby": "ecommerce-tab", children: _jsx(Card, { isPageContent: true, enableHover: false, children: _jsx(DashboardEcommerce, {}) }) }), _jsx("div", { className: `tab-pane fade ${activeTab === 'analytics' ? 'show active' : ''}`, id: "analytics", role: "tabpanel", "aria-labelledby": "analytics-tab", children: _jsx(Card, { isPageContent: true, enableHover: false, children: _jsx(DashboardAnalytics, {}) }) }), _jsx("div", { className: `tab-pane fade ${activeTab === 'ads' ? 'show active' : ''}`, id: "ads", role: "tabpanel", "aria-labelledby": "ads-tab", children: _jsx(Card, { isPageContent: true, enableHover: false, children: _jsx(DashboardAds, {}) }) }), _jsx("div", { className: `tab-pane fade ${activeTab === 'instagram' ? 'show active' : ''}`, id: "instagram", role: "tabpanel", "aria-labelledby": "instagram-tab", children: _jsx(Card, { isPageContent: true, enableHover: false, children: _jsx(DashboardInstagram, {}) }) }), isSuperAdmin && (_jsx("div", { className: `tab-pane fade ${activeTab === 'history' ? 'show active' : ''}`, id: "history", role: "tabpanel", "aria-labelledby": "history-tab", children: _jsx(Card, { isPageContent: true, enableHover: false, children: _jsx(ChangelogViewer, {}) }) }))] }) }) }));
};
export default Dashboard;
